import { NgModule } from '@angular/core';

import { LanguagePipe } from './language.pipe';
import { ProductFilterPipe } from './product-filter.pipe';
import { TextTruncatePipe } from './text-truncate.pipe';
import { RemoveUnderscorePipe } from './remove-underscore.pipe';
import { CustomeDatePipe } from './custome-date.pipe';

@NgModule({
  imports: [],
  declarations: [LanguagePipe, ProductFilterPipe, TextTruncatePipe, RemoveUnderscorePipe, CustomeDatePipe],
  exports: [LanguagePipe, ProductFilterPipe, TextTruncatePipe, RemoveUnderscorePipe,CustomeDatePipe],
})
export class PipeModule {
  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [LanguagePipe,CustomeDatePipe],
    };
  }
}
